<template>
  <section class="mobile-drawer">
    <button
      class="modal-open-button"
      @click="toggleTableOfContents"
    >
      <i
        class="fa-2x fas fa-list-alt prm"
      />
      <div class="">
        Contents
      </div>
    </button>
    <b-modal 
      :active.sync="isDrawerOpen"
      full-screen 
    >
      <TableOfContents :longform-document="longformDocument" />
      <button
        class="modal-close-button"
        @click="toggleTableOfContents"
      >
        <i
          class="fa-2x fas fa-times prm"
        />
        <div>
          Close
        </div>
      </button>
    </b-modal>
    <b-sidebar
      type="is-light"
      :fullheight="fullheight"
      :overlay="overlay"
      :open.sync="open"
    >
      <div class="p-1">
        <button
          aria-label="Close sidebar"
          class="sidebar-close-button"
          @click="toggleTableOfContents"
        >
          <i
            class="fa-2x fas fa-times prm"
          />
        </button>
        <TableOfContents :longform-document="longformDocument" />
      </div>
    </b-sidebar>
  </section>
</template>

<script>
import TableOfContents from '@/components/TableOfContents.vue';

export default {
  name: 'TableOfContentsMobileDrawer',
  components: {
    TableOfContents,
  },
  props: {
    longformDocument: {
      type: Object,
      required: true,
    },
    sidebar: {
      type: Boolean,
      default: false,
    },
  }, 
  data: function() {
    return {
      isDrawerOpen: false,
      open: false,
      overlay: false,
      fullheight: true,
    };
  },
  watch:{
    $route (){
      this.closeAll();
    },
  },
  methods: {
    toggleTableOfContents() {
      let vm = this;
      if (vm.sidebar) {
        vm.open = !vm.open;
      } else {
        vm.isDrawerOpen = !vm.isDrawerOpen;
      }
    },
    closeAll() {
      let vm = this;
      vm.open = false;
      vm.isDrawerOpen = false;
    },
  },
};
</script>